/* eslint max-len: 0 */
import React, { SVGProps } from "react";

import { useIconIdPrefix } from "~/components/Icons/utils/useIconIdPrefix";

const YoutubePremium = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  const prefix = useIconIdPrefix("YoutubePremium");

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon--youtubePremium"
      {...props}
    >
      <g clipPath={`url(#${prefix}-clip0_8751_5054)`}>
        <path
          d="M4.00033 0.666656C2.16699 0.666656 0.666992 2.16666 0.666992 3.99999V9.33332C0.666992 9.56666 0.666992 9.79999 0.733659 9.99999H2.00033V3.99999C2.00033 2.89999 2.90033 1.99999 4.00033 1.99999H12.0003C13.1003 1.99999 14.0003 2.89999 14.0003 3.99999V9.99999H15.267C15.267 9.79999 15.3337 9.56666 15.3337 9.33332V3.99999C15.3337 2.16666 13.8337 0.666656 12.0003 0.666656H4.00033Z"
          fill="white"
        />
        <path
          d="M14.6663 11.3333H1.33301C1.93301 12.1333 2.89967 12.6667 3.99967 12.6667H7.33301V14H3.33301V15.3333H12.6663V14H8.66634V12.6667H11.9997C13.0997 12.6667 14.0663 12.1333 14.6663 11.3333Z"
          fill="white"
        />
        <path
          d="M8 9.33331C8 9.33331 10.5 9.33331 11.1333 9.16664C11.5 9.06664 11.7333 8.79997 11.8333 8.46664C12 7.83331 12 6.53331 12 6.53331C12 6.53331 12 5.23331 11.8333 4.59997C11.7333 4.26664 11.4667 3.96664 11.1333 3.89997C10.5 3.73331 8 3.73331 8 3.73331C8 3.73331 5.5 3.73331 4.86667 3.89997C4.53333 3.99997 4.26667 4.26664 4.16667 4.59997C4 5.23331 4 6.53331 4 6.53331C4 6.53331 4 7.83331 4.16667 8.46664C4.26667 8.79997 4.53333 9.06664 4.86667 9.16664C5.5 9.33331 8 9.33331 8 9.33331Z"
          fill="white"
        />
        <path d="M9.36615 6.26667L7.13281 4.96667V7.56668L9.36615 6.26667Z" fill="#2D3548" />
      </g>
      <defs>
        <clipPath id={`${prefix}-clip0_8751_5054`}>
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

YoutubePremium.displayName = "youtubePremium";

export default YoutubePremium;
